<template>
  <b-button :to="route" :title="$i18n.t(title)" :class="classObject"
            v-b-modal="vbModalId" @click="$emit('click')"
  >
    <font-awesome v-if="faClass" :class="'float-' + faPosition"
                  :fa-class="faClass"
    />

    <span v-if="text">{{ $t(text) }}</span>

    <b-modal v-if="deletionData" :id="deletionModalId"
             :cancel-title="$t('_cancel')" @ok="confirmDeletion"
    >
      {{ $t('_delete_question') }}
    </b-modal>

    <b-modal v-if="deletionData" :id="confirmDeletionModalId"
             :ok-only="true" @ok="onDeletionInfo"
    >
      {{ $t('_delete_confirm') }}
    </b-modal>
  </b-button>
</template>

<script>
import bButton from 'bootstrap-vue/es/components/button/button'
import fontAwesome from '@/components/global/icon/fontAwesome'
import AbstractApi from '@/api/abstractApi'

export default {
  components: {
    bButton,
    fontAwesome
  },

  props: {
    route: [Object, String],
    text: String,
    title: String,
    faClass: String,
    faPosition: {
      type: String,
      default: 'none'
    },
    bootstrapClass: String,
    deletionData: Object
  },

  methods: {
    confirmDeletion () {
      let api = new AbstractApi(this.deletionData.entityName, this.deletionData.entityId)
      api.disableEntity({ enabled: false }).then(response => {
        if (response.data.isValid) this.$bvModal.show(this.confirmDeletionModalId)
      })
    },

    onDeletionInfo () {
      let entity = this.$route.name.split('_')[0]
      let listRoute = `${entity}_list`

      if (this.$route.name !== listRoute) {
        this.$router.go(-1)
      } else {
        this.$emit('needReload')
      }
    }
  },

  computed: {
    classObject () {
      // if no text => btn small
      if (this.text) return this.bootstrapClass
      else return this.bootstrapClass + ' btn-sm'
    },

    deletionModalId () {
      return `deletion-${this.deletionData.entityName}-${this.deletionData.entityId}`
    },

    confirmDeletionModalId () {
      return `confirmed-${this.deletionModalId}`
    },

    vbModalId () {
      return this.deletionData ? this.deletionModalId : null
    }
  }
}
</script>
